import { device } from '@accedo/xdk-core'
import { Settings } from '@lightningjs/sdk'
import { Flo } from '../../types/flo-auth-api'
import { generateHmac, getUserData } from '../../utils/authentication'
import { AppConfig } from '../appConfig'

const serverName = 'PRD'
const urlDPI = 'https://checkoutapi.samsungcheckout.com/openapi'

export class TizenSubscriptionService implements ISubscriptionService {
  private _uniqueId: string
  private _countryCode: string
  private _productsList: ProductList = []
  private _appId: string
  private _securityKey: string

  initialize() {
    this._appId = Settings.get('app', 'env.APP_TIZEN_ID')
    this._securityKey = Settings.get('app', 'env.APP_TIZEN_SECURITY_KEY')

    try {
      this._uniqueId = getUserData()?.user_id?.toString()
    } catch (e) {
      console.log('webapis.sso.getLoginUid Error : ' + e.message)

      // If not login status, Show samsung account UI
      if (webapis.sso.getLoginStatus() == 0) {
        // SSO_NOT_LOGIN : 0 / SSO_LOGIN : 1
        webapis.sso.showAccountView(
          'Samsung Login',
          (data) => {
            console.log('Current Status is ' + data.status)
            console.log('Show Samsung account UI for login')
          },
          (e) => {
            console.log('webapis.sso.showAccountView Error : ' + e.message)
          },
        )
      }
    }

    // get country code value from TV
    this._countryCode = webapis.productinfo.getSystemConfig(
      webapis.productinfo.ProductInfoConfigKey.CONFIG_KEY_SERVICE_COUNTRY,
    )

    console.log('uniqueId : ' + this._uniqueId + ', countryCode : ' + this._countryCode)
  }

  getType(): string {
    return 'samsung'
  }

  async getProducts(): Promise<ProductList> {
    console.log('Request Products List')

    this._productsList = []

    // configure required property for detail object
    var detail = {} as any
    detail.AppID = this._appId
    detail.CountryCode = this._countryCode
    detail.PageSize = 100
    detail.PageNumber = 1
    detail.CheckValue = generateHmac(detail.AppID + detail.CountryCode, this._securityKey)

    var paymentDetails = JSON.stringify(detail)

    const response = await fetch(urlDPI + '/cont/list', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: paymentDetails,
    })

    if (response.status === 200) {
      const rawResp = (await response.json()) as ITizenProductListApiResponse
      if (rawResp.TotalCount >= 1) {
        this._productsList = this._convertProducts(rawResp)
      }
    }

    return this._productsList
  }

  _convertProducts(rawResp: ITizenProductListApiResponse): ProductList {
    return rawResp.ItemDetails?.map((v) => ({
      currency: v.CurrencyID,
      description: v.ItemDesc,
      title: v.ItemTitle,
      id: v.ItemID,
      price: v.Price,
    }))
  }

  buyProduct(product: IProduct): Promise<Purchase> {
    if (this._productsList.length < 1) {
      return null
    }

    console.log('Request Buy Item')

    var selectedItemDetails = product

    // configure required property for detail object
    var detail = {} as ITizenBuyProductRequest
    detail.OrderItemID = selectedItemDetails.id
    detail.OrderTitle = selectedItemDetails.title
    detail.OrderTotal = selectedItemDetails.price.toString()
    detail.OrderCurrencyID = selectedItemDetails.currency
    detail.OrderCustomID = this._uniqueId

    var paymentDetails = JSON.stringify(detail)

    return new Promise((resolve) => {
      try {
        webapis.billing.buyItem(
          this._appId,
          serverName,
          paymentDetails,
          (data) => {
            console.log('requestBuyItem success')
            console.log('[payResult] : ' + data.payResult + ', [payDetail] : ' + data.payDetail)

            // https://developer.samsung.com/smarttv/develop/guides/samsung-checkout/implementing-the-purchase-process.html#Billing-API
            if (data.payResult === 'SUCCESS') {
              const resp = JSON.parse(data.payDetail)
              console.log('success return', resp)
              resolve({ invoiceId: resp.InvoiceID })
            } else if (data.payResult === 'CANCEL') {
              console.log('purchase canceled by the user', data)
              resolve({ isPurchaseCanceled: true })
            } else if (data.payResult === 'FAILED') {
              console.log('purchase failed', data)
              resolve(null)
            }
          },
          (e) => {
            console.log('requestBuyItem error : ' + e.message)
            resolve(null)
          },
        )
      } catch (e) {
        console.log('webapis.billing.buyItem Exception : ' + e.message)
        resolve(null)
      }
    })
  }

  async createSubscription(
    offer: Flo.Offers.OffersResponseData,
    subscriptionId: string,
  ): Promise<Flo.Payments.SubscriptionResponse> {
    const userData = getUserData()
    return await AppConfig.shared.authService.createSubscription({
      type: AppConfig.shared.subscriptionService.getType(),
      samsungDpiSubscriptionCountry: device.system.getCountry() || 'US',
      samsungDpiSubscriptionId: subscriptionId,
      offering: offer.id,
      user: userData.user_id,
    })
  }
}
